import { createSelector } from 'reselect';

import { LoadBenefitPageType } from '@epi-constants/onboardingTypes';

export interface OnboardingState {
  paymentPath:
    | 'directLoadNoLounari'
    | 'directLoadOnlyLounari'
    | 'directLoadMultiple'
    | 'topupOnlyLounari'
    | 'topupMultiple';
  isSecondStep: boolean;
  loadBenefitType: LoadBenefitPageType;
  keepOnboardingActive: boolean;
  rehydrated?: boolean;
}

const getOnboarding = (state): OnboardingState => state.onboarding;

export const getOnboardingPaymentPath = createSelector(
  getOnboarding,
  state => state.paymentPath
);

export const getOnboardingLoadBenefitPageType = createSelector(
  getOnboarding,
  state => state.loadBenefitType
);

export const getOnboardingActive = createSelector(
  getOnboarding,
  state => state.keepOnboardingActive
);

export const getOnboardingIsSecondStep = createSelector(
  getOnboarding,
  state => state.isSecondStep
);
